import React, { useState } from "react";
import { toast } from "../../../../components/toastNotification";
import useGetEmailWorkFLow from "./hooks/useEmailWorkFlow";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddEmailWorkFlow from "./hooks/useAddEmailWorkFlow";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { addStateEmailWorkFlow } from "./atoms/atoms";
import MultiSelectInput from "../../../../components/MultiSelectInput";
import useOperations from "./hooks/useOperations";
import useEvents from "./hooks/useEvents";
import { useQueryClient } from "react-query";
import SelectInput from "../../../../components/SelectInput";
import CancelButton from "../../../../components/CancelButton";
import SaveButton from "../../../../components/SaveButton";
const AddEmailWorkFlowForm = () => {
  //Hooks
  const { mutateAsync: AddEmailWorkFlow } = useAddEmailWorkFlow();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateEmailWorkFlow
  );
  const queryClient = useQueryClient();
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasEmailWorkFlow, setHasEmailWorkFlow] = useState(false);
  const [events, setEvents] = useState("");
  const defaulValues = {
    events: "",
    operationIds: [],
  };
  const [newEmailWorkFlow] = useState([defaulValues]);
  const { data: emailWorkFlowData } = useGetEmailWorkFLow();
  const { data: operationsTypeQuery } = useOperations();
  const { data: eventsTypeQuery } = useEvents();
  const eventsType =
    eventsTypeQuery &&
    eventsTypeQuery.map((x) => {
      return { value: x.eventId, label: x.eventName };
    });
  const handleAddEmailWorkFlow = (sourceType, fieldName, inputvalue) => {
    setChanged(true);
    if (sourceType === "addEmailWorkFlow") {
      if (fieldName === "events") {
        newEmailWorkFlow.map((x) =>
          inputvalue !== null ? (x.events = inputvalue) : (x.events = "")
        );
      }
    }
    handleSaveButton();
  };

  const handleMultiSelectModule = (checkedOperations) => {
    const operationsId = [];
    checkedOperations.forEach((m) => {
      operationsId.push(m.value);
    });
    newEmailWorkFlow.map((x) => (x.operationIds = operationsId));
    handleSaveButton();
  };
  const handleSaveButton = () => {
    newEmailWorkFlow.map((x) =>
      x.events !== "" && x.operationIds.length !== 0
        ? setHasEmailWorkFlow(true)
        : setHasEmailWorkFlow(false)
    );
  };
  const dropDownOperations = operationsTypeQuery.map((m) => {
    return { label: m.operationName, value: m.operationId };
  });

  //check duplicates
  function dataExists(event) {
    return emailWorkFlowData.some(function (el) {
      return el.events.toLowerCase().trim() === event.toLowerCase().trim();
    });
  }
  //save changes
  const handleSave = (newEmailWorkFlow) => {
    if (changed) {
      if (!dataExists(newEmailWorkFlow[0].events)) {
        AddEmailWorkFlow(newEmailWorkFlow, {
          onSuccess: (res) => {
            queryClient.invalidateQueries(["GetEmailWorkFlow"]);
            queryClient.invalidateQueries(["FilteredOperation"]);
            setActionAddState(!actionAddState);
            setOpenModal(false);
            toast.fire(
              "Success",
              "Email Workflow Added Successfully",
              "success"
            );
          },
          onError: (error) => {
            toast.fire("Failed", "Failed to Add Email Workflow", "error");
          },
        });
      } else {
        toast.fire(
          "Saving Failed",
          "Email Workflow already exists!",
          "warning"
        );
        setOpenModal(false);
      }
    } else {
      toast.fire("Failed", "Please populate fields!", "error");
      setOpenModal(false);
    }
  };

  // end of saving changes
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#edebeb",
      minHeight: "28px",
      //   height: "9px",
      boxShadow: state.isFocused ? null : null,
      fontSize: "12px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const matcolumns = [
    {
      title: "Events",
      field: "events",
      render: (rowData) => {
        return (
          <div className="w-full ">
            <div className="">
              <SelectInput
                options={eventsType}
                isDisabled={false}
                value={events}
                onChange={(e) => {
                  setEvents(e);
                  handleAddEmailWorkFlow(
                    "addEmailWorkFlow",
                    "events",
                    e ? e.label : null
                  );
                }}
              />
              {/* <TextInput
                placeholder="Events"
                onChange={(inputdata) => {
                  handleAddEmailWorkFlow(
                    "addEmailWorkFlow",
                    "events",
                    inputdata.target.value
                  );
                }}
              /> */}
            </div>
          </div>
        );
      },
    },
    {
      title: "Operations Group",
      field: "operations",
      render: (rowData) => {
        return (
          <div className="w-full">
            <div className="w-full">
              <MultiSelectInput
                menuPortalTarget={document.body}
                styles={customStyles}
                isMulti
                closeMenuOnSelect={false}
                options={dropDownOperations}
                className="basic-multi-select"
                classNamePrefix="select"
                handleMultiSelect={handleMultiSelectModule}
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="">
      <div className="w-full  ">
        <ConfirmBoxModal
          ModalTitle="Add Email Workflow"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(newEmailWorkFlow);
          }}
        />
        <div className="animate-fade-in-down1 py-2 box-shadow border-primary border-l-2">
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="text-base text-primary font-bold pl-3">
                Add New Email Workflow
              </div>
              <div className="flex items-center space-x-2 mx-3">
                <SaveButton
                  className={`flex justify-center shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasEmailWorkFlow ? "opacity-50" : "opactiy-100"}`}
                  disabled={!hasEmailWorkFlow}
                  onClick={() => {
                    setOpenModal(true);
                  }}
                />
                <CancelButton
                  className="flex justify-center text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                  onClick={() => setActionAddState(!actionAddState)}
                />
              </div>
            </div>
            <div className="mr-3 ml-3 border-b-2 border-secondary"></div>
          </div>
          {/* <div className="py-3"></div> */}

          <div className="py-2 pt-3 pr-3 pl-3">
            <MaterialExTable
              columns={matcolumns}
              data={newEmailWorkFlow}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="py-1"></div>
        </div>
      </div>
    </div>
  );
};

export default AddEmailWorkFlowForm;
